import { render, staticRenderFns } from "./Sync.vue?vue&type=template&id=75cf36d8&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Sync.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Sync.vue
// module id = 1741
// module chunks = 1